import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classnames from 'classnames';
import { facultyGetAllSubjects, facultyAddSubject } from '../../redux/action/facultyAction';
import FacultyHomeHelper from '../../Components/FacultyHomeHelper';
import { useHistory, Link } from 'react-router-dom'
import Loading from '../../Components/Loading';

const FacultyAssignment = () => {
  const store = useSelector((store) => store);
  const dispatch = useDispatch();
  const [year, setYear] = useState('');
  const [semester, setSemester] = useState('');
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const history = useHistory();
  const department = store.faculty.faculty.faculty.department;
  const [subjectName, setSubjectName] = useState('')
  const [subjectCode, setSubjectCode] = useState('')
  const [subType, setSubjectType] = useState('')
  const [subModel, setSubjectModel] = useState('')
  const [subCredit, setCredit] = useState('')
  useEffect(() => {
    dispatch(facultyGetAllSubjects({ department }));
    console.log(department);
  }, [department]); // Add department to the dependency array


  useEffect(() => {
    if (store.faculty.allSubject.length !== 0) {
      setIsLoading(false);
    }
  }, [store.admin.allSubject.length]);

  const isDataAvailable = store.faculty.allSubject && store.faculty.allSubject.length > 0;

  // Filter subjects based on the selected semester
  const filteredSubjects = store.faculty.allSubject.filter((subject) => {
    return semester ? subject.semester === semester : true;
  });

  // Apply search filter to subjects based on the searchQuery
  const searchedSubjects = filteredSubjects.filter((subject) => {
    const searchFields = Object.values(subject).map((value) => value?.toString() || '');
    const normalizedQuery = searchQuery.toLowerCase().trim();
    return searchFields.some((field) => field.toLowerCase().includes(normalizedQuery));
  });

  const formHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    dispatch(facultyAddSubject({
      subjectCode,
      subjectName,
      semester,
      subCredit,
      subModel,
      department,
      subType,
      year
    }))
  };

  return (
    <div>
      {store.faculty.isAuthenticated ? (
        <>
          <div className="container-fluid p-0">
            <div className="d-flex">
              <div className="print-helper">
                <FacultyHomeHelper />
              </div>
              <div className="mx-1 w-100 ">
                <div className="px-3 py-1 bg-light d-flex align-items-center justify-content-between">
                  <h3>
                    {' '}
                    <img src="/logo192.png" width={'50px'} alt="" /> Subject's
                  </h3>
                  <button onClick={() => window.print()} type="button" className=" btn-success btn text-light">
                    {' '}
                    <img src="/image/print.svg" alt="" /> Download
                  </button>
                </div>
                <div className="col d-flex align-items-center justify-content-between">
                  <form noValidate className="d-flex align-items-center justify-content-start" onSubmit={formHandler}>
                    <div className="form-group mx-2 print-helper">
                      <label htmlFor="departmentId">Department</label>
                      <h4>{department}</h4>
                      {error.department && (<div className="invalid-feedback">{error.department}</div>)}
                    </div>
                    <div className="form-group mx-2 print-helper">
                      <label htmlFor="semesterId">Semester</label>
                      <select
                        onChange={(e) => {
                          setSemester(e.target.value);
                        }}
                        className={classnames('form-control', {
                          'is-invalid': error.section,
                        })}
                        id="semesterId"
                      >
                        <option>Select</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                      </select>
                      {error.semester && <div className="invalid-feedback">{error.semester}</div>}
                    </div>
                    <div className="mt-3">
                      {!isLoading && <button type="submit" className="btn btn-info btn-block  ">
                        Search
                      </button>}
                      {isLoading && (
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      )}
                    </div>
                  </form>
                  <button type="button" className="btn btn-success " data-bs-toggle="modal" data-bs-target="#exampleModalLabel25">
                    <img src="/image/add.svg" alt="" className='m-1' />  Add Subject
                  </button>

                  <div class="modal fade" id="exampleModalLabel25" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h4 class="modal-title fs-5" id="exampleModalLabel">Add Subject</h4>
                        </div>
                        <form noValidate onSubmit={formHandler} className='w-100'>
                          <div class="modal-body">
                            <div className="row d-flex my-2 align-items-center justify-content-center w-100">
                              <div className="col-md-5">
                                <div className="form-group">
                                  <label htmlFor="departmentId">Department</label>
                                  <h5>{department}</h5>
                                  {error.department && (<div className="invalid-feedback">{error.department}</div>)}
                                </div>
                                <div className="form-group">
                                  <label htmlFor="snameId">Subject Name</label>
                                  <input onChange={(e) => setSubjectName(e.target.value)} type="text" className={classnames("form-control",
                                    {
                                      'is-invalid': error.subjectName
                                    })} id="snameId" />
                                  {error.subjectName && (<div className="invalid-feedback">{error.subjectName}</div>)}
                                </div>
                                <div className="form-group">
                                  <label htmlFor="scodeId">Subject Code</label>
                                  <input onChange={(e) => setSubjectCode(e.target.value)} type="text" className={classnames("form-control",
                                    {
                                      'is-invalid': error.subjectCode
                                    })} id="scodeId" />
                                  {error.subjectCode && (<div className="invalid-feedback">{error.subjectCode}</div>)}
                                </div>
                                <div className="form-group">
                                  <label htmlFor="CreditId">Credit</label>
                                  <input onChange={(e) => setCredit(e.target.value)} type="text" className={classnames("form-control",
                                    {
                                      'is-invalid': error.credit
                                    })} id="CreditId" />
                                  {error.credit && (<div className="invalid-feedback">{error.credit}</div>)}
                                </div>

                              </div>
                              <div className="col-md-5">
                                <div className="form-group">
                                  <label htmlFor="subjectModelId">Subject Model</label>
                                  <select onChange={(e) => setSubjectModel(e.target.value)} className={classnames("form-control",
                                    {
                                      'is-invalid': error.subjectModel
                                    })} id="subjectModelId">
                                    <option>Select</option>
                                    <option value="Normal">Normal</option>
                                    <option value="Professional Elective">Professional Elective</option>
                                    <option value="Open Elective">Open Elective</option>
                                  </select>
                                  {error.subjectModel && (<div className="invalid-feedback">{error.subjectModel}</div>)}
                                </div>
                                <div className="form-group">
                                  <label htmlFor="setSubjectTypeId">Subject Type</label>
                                  <select onChange={(e) => setSubjectType(e.target.value)} className={classnames("form-control",
                                    {
                                      'is-invalid': error.subjectType
                                    })} id="setSubjectTypeId">
                                    <option>Select</option>
                                    <option value="Theory">Theory</option>
                                    <option value="Lab come Theory">Lab come Theory</option>
                                    <option value="Practical">Practical</option>
                                    <option value="Others">Others</option>
                                  </select>
                                  {error.subjectType && (<div className="invalid-feedback">{error.subjectType}</div>)}
                                </div>
                                <div className="form-group">
                                  <label htmlFor="semesterId">Semester</label>
                                  <select onChange={(e) => setSemester(e.target.value)} className={classnames("form-control",
                                    {
                                      'is-invalid': error.semester

                                    })} id="semesterId">
                                    <option>Select</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                  </select>

                                  {error.semester && (<div className="invalid-feedback">{error.semester}</div>)}
                                </div>

                                <div className="form-group">
                                  <label htmlFor="yearId">Year</label>
                                  <select onChange={(e) => setYear(e.target.value)} className={classnames("form-control",
                                    {
                                      'is-invalid': error.year

                                    })} id="yearId">
                                    <option>Select</option>
                                    <option value="I">I</option>
                                    <option value="II">II</option>
                                    <option value="III">III</option>
                                    <option value="IV">IV</option>
                                  </select>

                                  {error.year && (<div className="invalid-feedback">{error.year}</div>)}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="submit" className="btn btn-info m-3 "> <img src="/image/add.svg" alt="" /> Add Subject</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                {isDataAvailable ? (
                  <div className="col">
                    {searchedSubjects.length !== 0 && (
                      <table className="mt-3 table table-responsive table table-bordered table-striped">
                        <thead>
                          <tr className="bg-secondary text-light">
                            <th scope="col" width="10%">
                              S.No
                            </th>
                            <th scope="col" width="20%">
                              Subject Code
                            </th>
                            <th scope="col" width="10%">
                              Department
                            </th>
                            <th scope="col" width="10%">
                              Year
                            </th>
                            <th scope="col" width="10%">
                              Semester
                            </th>
                            <th scope="col" width="30%">
                              Subject Name
                            </th>
                            <th scope="col" width="10%">
                              Type
                            </th>
                            <th scope="col" width="10%">
                              Credit
                            </th>
                            <th scope="col" width="20%">
                              Notes
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {searchedSubjects.map((res, index) => (
                            <tr key={index}>
                              <th scope="row">{index + 1}</th>
                              <td>{res.subjectCode}</td>
                              <td>{res.department}</td>
                              <td>{res.year}</td>
                              <td>{res.semester}</td>
                              <td>{res.subjectName}</td>
                              <td>Theory</td>
                              <td>4</td>
                              <td>
                                <button className="btn btn-success">Upload</button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                ) : (
                  <Loading />
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        history.push('/')
      )}
    </div>
  );
};

export default FacultyAssignment;
